var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDollarCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.25C8.41421 2.25 8.75 2.58579 8.75 3V5C8.75 5.41421 8.41421 5.75 8 5.75C7.58579 5.75 7.25 5.41421 7.25 5V3C7.25 2.58579 7.58579 2.25 8 2.25Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4194 3.58058C9.97865 1.13981 6.02137 1.1398 3.58059 3.58059L3.58058 3.58059C1.13981 6.02135 1.1398 9.97863 3.58059 12.4194C6.02135 14.8602 9.97863 14.8602 12.4194 12.4194C14.8601 9.97876 14.8602 6.02174 12.4198 3.58093C12.4196 3.58081 12.4195 3.5807 12.4194 3.58058ZM13.4795 2.51933C10.4529 -0.506643 5.54629 -0.506442 2.51993 2.51992L13.4795 2.51933ZM13.4795 2.51933C13.4797 2.51953 13.4799 2.51973 13.4801 2.51993C16.5066 5.54649 16.5066 10.4535 13.4801 13.4801C10.4535 16.5066 5.54648 16.5066 2.51993 13.4801C-0.50664 10.4535 -0.506643 5.54648 2.51993 2.51993",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.25C8.41421 10.25 8.75 10.5858 8.75 11V13C8.75 13.4142 8.41421 13.75 8 13.75C7.58579 13.75 7.25 13.4142 7.25 13V11C7.25 10.5858 7.58579 10.25 8 10.25Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40467 5.625C6.97352 5.625 6.625 5.97382 6.625 6.40389C6.625 6.7606 6.86773 7.07191 7.21458 7.15887C7.21459 7.15888 7.21461 7.15888 7.21463 7.15889L9.08924 7.62861L9.0893 7.62862C9.99175 7.85484 10.625 8.66556 10.625 9.59611C10.625 10.7174 9.71532 11.625 8.59533 11.625H7.5C6.32648 11.625 5.375 10.6745 5.375 9.50083C5.375 9.15565 5.65482 8.87583 6 8.87583C6.34518 8.87583 6.625 9.15565 6.625 9.50083C6.625 9.98353 7.01618 10.375 7.5 10.375H8.59533C9.02601 10.375 9.375 10.026 9.375 9.59611C9.375 9.2394 9.13227 8.92809 8.78542 8.84113C8.78541 8.84112 8.78539 8.84112 8.78537 8.84111L6.91076 8.37139L6.9107 8.37138C6.00825 8.14516 5.375 7.33444 5.375 6.40389C5.375 5.28281 6.28382 4.375 7.40467 4.375H8.5C9.67352 4.375 10.625 5.32546 10.625 6.49917H9.375C9.375 6.01647 8.98382 5.625 8.5 5.625H7.40467Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarCircle);
export default __webpack_public_path__ + "static/media/icon-dollar-circle.8333f73f17826054b3614f3b4f765e8e.svg";
export { ForwardRef as ReactComponent };